import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Bug } from "lucide-react";
import ReportBugSheet from "./ReportBugSheet";

/**
 * Floating "Report a Bug" pill, mounted globally. Opens an in-page sheet
 * (like the Tutor FAB) so users stay on the page they were debugging.
 * Hidden on the Feedback page itself and on admin routes.
 */
const ReportBugButton = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  // Close the sheet on route change so it never lingers over a new page.
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // Allow the unified menu (or any other surface) to pop the bug sheet
  // open without needing the floating button to be visible.
  useEffect(() => {
    const fn = () => setOpen(true);
    window.addEventListener("open-bug", fn);
    return () => window.removeEventListener("open-bug", fn);
  }, []);

  if (pathname.startsWith("/feedback") || pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <>
      <ReportBugSheet open={open} onOpenChange={setOpen} />
    </>
  );
};

export default ReportBugButton;
